/**
 * Returns true if the given mime type is considered an image.
 */
export function isImageMimeType(mimeType: string) {
    return mimeType.startsWith('image');
}
